var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-data-centers-local',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isAvailable),expression:"isAvailable"}]},'s-data-centers-local',_vm.content,false))
}
var staticRenderFns = []

export { render, staticRenderFns }